<template>
  <div class="friend-choose-plate" v-show="show" :style="style" ref="plate" @click.stop>
    <FriendChooseV2 @change="change" ref="child" :limit="limit" v-if="show" :selected="selected"></FriendChooseV2>
    <BaseMask v-if="show" @click.native.stop="hide" :styles="{'background-color':'transparent', 'z-index': style['z-index'] - 1}"></BaseMask>
  </div>
</template>

<script>
    import FriendChooseV2 from "../baseComponent/FriendChooseV2"
    import bus from "../../js/bus/chooseFriendBus";
    import BaseMask from "../baseComponent/BaseMask"
    import setting from "../../config/setting";
    import { lookElementXY } from "../../js/utils/domLocation";
    import { nextZIndex } from "../../js/utils/zIndexUtil";

    export default {
        name: "FriendChoosePlate",
        components: {FriendChooseV2, BaseMask},
        created(){
            //监听组件占用事件，记录占用者的id
            bus.onShow((domRect, selected, limit) => {
                setTimeout(() => {
                    this.show = true;
                    this.selected = selected.slice(0, limit);
                    this.limit = limit;
                    this.$nextTick(() => {
                        this.style = lookElementXY(domRect, this.$refs.plate.getBoundingClientRect());
                        this.style['z-index'] = nextZIndex();
                        window.addEventListener('scroll', this.hide);
                    });
                }, 100);
            });
        },
        mounted() {
            this.$removeToBody();
        },
        data() {
            return {
                show: false,
                //面板位置
                style: {top: "0", left: "0", 'z-index': 0},
                //当前已选择的好友
                selected: [],
                //勾选限制
                limit: 50
            }
        },
        methods: {
            hide() {
                this.show = false;
                window.removeEventListener('scroll', this.hide);
            },
            change(arr) {
                this.hide();
                bus.callback(arr);
            }
        }
    }
</script>
<style scoped>
  .friend-choose-plate {
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/view/baseComponent/FriendChoosePlate.vue